import participant_client_roles from "dictionaries/participant_client_roles.json";
import createOptions from "utils/createOptions";

export default createOptions(participant_client_roles);
